<template>
    <div class="qksm qksm9">
        <h4>九、一般公共预算财政拨款“三公”经费、会议费、培训费支出情况说明</h4>
        <div class="nogap">
            <p>
                {{$store.state.divData.divname}}2020年度一般公共预算拨款安排的“三公”经费决算支出中，
                因公出国（境）费支出{{isMoney(T9.items.因公出国)}}万元，占“三公”经费的{{getPercentValue(T9.prop.map(e=>e.value), 0, 2)}}；
                公务用车购置及运行维护费支出{{isMoney(T9.items.公务用车)}}万元，占“三公”经费的{{getPercentValue(T9.prop.map(e=>e.value), 1, 2)}}；
                公务接待费支出{{isMoney(T9.items.公务接待)}}万元，占“三公”经费的{{getPercentValue(T9.prop.map(e=>e.value), 2, 2)}}。
                具体情况如下：
            </p>
            <p>
                1．因公出国（境）费决算支出{{isMoney(T9.items.因公出国)}}万元
                <span class="hide_pdf">
                    （预算数<reason type="money" classname="qksm money" name="因公出国年初" v-model:value="qksm['因公出国年初']"></reason>万元，
                    去年决算数<reason type="money" classname="qksm money nullable" name="因公出国去年" v-model:value="T9.items_last.因公出国"></reason>万元）
                </span>
                <span v-if="num(qksm['因公出国年初'])==0">
                    {{$store.state.divData.zone=='xuzhou' ? "，年初无预算，" : "（预算数为0万元，无法计算完成比例），"}}
                </span>
                <span v-else>
                    ，完成预算的{{calcRatio(T9.items.因公出国,qksm['因公出国年初'])}}，
                </span>
                <span v-if="num(T9.items.因公出国).toFixed(2)==num(T9.items_last.因公出国).toFixed(2)">
                    与上年决算相同；
                </span>
                <span v-else>
                    比上年决算{{growthValueText(T9.items.因公出国,T9.items_last.因公出国)}}万元，
                    主要原因为<reason type="textarea" classname="qksm widest semicolon" name="因公出国决算原因" v-model:value="qksm['因公出国决算原因']"></reason>
                </span>
                <span v-if="num(T9.items.因公出国)!=num(qksm['因公出国年初'])">
                    决算数{{num(T9.items.因公出国)>num(qksm['因公出国年初']) ? "大于" : "小于"}}预算数的主要原因
                    <reason type="textarea" classname="qksm widest" name="因公出国预算原因" v-model:value="qksm['因公出国预算原因']"></reason>
                </span>
                <span v-else>
                    决算数等于预算数。
                </span>
                全年使用一般公共预算拨款支出安排的出国（境）团组{{T9.统计数[0].c}}个，累计{{T9.统计数[0].f}}人次。
                <template v-if="num(T9.items.因公出国)!=0">
                    开支内容主要为：
                    <reason type="textarea" classname="qksm widest" name="因公出国开支内容" v-model:value="qksm['因公出国开支内容']"></reason>
                </template>
            </p>
            <p>2．公务用车购置及运行维护费支出{{isMoney(T9.items.公务用车)}}万元。其中：</p>
            <p>
                （1）公务用车购置决算支出{{isMoney(T9.items.购置费)}}万元
                <span class="hide_pdf">
                    （预算数<reason type="money" classname="qksm money" name="购置费年初" v-model:value="qksm['购置费年初']"></reason>万元，
                    去年决算数<reason type="money" classname="qksm money nullable" name="购置费去年" v-model:value="T9.items_last.购置费"></reason>万元）
                </span>
                <span v-if="num(qksm['购置费年初'])==0">
                    {{$store.state.divData.zone=='xuzhou' ? "，年初无预算，" : "（预算数为0万元，无法计算完成比例），"}}
                </span>
                <span v-else>
                    ，完成预算的{{calcRatio(T9.items.购置费,qksm['购置费年初'])}}，
                </span>
                <span v-if="num(T9.items.购置费).toFixed(2)==num(T9.items_last.购置费).toFixed(2)">
                    与上年决算相同；
                </span>
                <span v-else>
                    比上年决算{{growthValueText(T9.items.购置费,T9.items_last.购置费)}}万元，
                    主要原因为<reason type="textarea" classname="qksm widest semicolon" name="购置费决算原因" v-model:value="qksm['购置费决算原因']"></reason>
                </span>
                <span v-if="num(T9.items.购置费)!=num(qksm['购置费年初'])">
                    决算数{{num(T9.items.购置费)>num(qksm['购置费年初']) ? "大于" : "小于"}}预算数的主要原因
                    <reason type="textarea" classname="qksm widest" name="购置费预算原因" v-model:value="qksm['购置费预算原因']"></reason>
                </span>
                <span v-else>
                    决算数等于预算数。
                </span>
                本年度使用一般公共预算拨款购置公务用车{{T9.统计数[1].c}}辆
                <template v-if="num(T9.items.购置费)!=0">
                    ，主要为：
                    <reason type="textarea" classname="qksm widest" name="公务用车购置" v-model:value="qksm['公务用车购置']"></reason>
                </template>
                <template v-else>
                    。
                </template>
            </p>
            <p>
                （2）公务用车运行维护费决算支出{{isMoney(T9.items.运行费)}}万元
                <span class="hide_pdf">
                    （预算数<reason type="money" classname="qksm money" name="运行费年初" v-model:value="qksm['运行费年初']"></reason>万元，
                    去年决算数<reason type="money" classname="qksm money nullable" name="运行费去年" v-model:value="T9.items_last.运行费"></reason>万元）
                </span>
                <span v-if="num(qksm['运行费年初'])==0">
                    {{$store.state.divData.zone=='xuzhou' ? "，年初无预算，" : "（预算数为0万元，无法计算完成比例），"}}
                </span>
                <span v-else>
                    ，完成预算的{{calcRatio(T9.items.运行费,qksm['运行费年初'])}}，
                </span>
                <span v-if="num(T9.items.运行费).toFixed(2)==num(T9.items_last.运行费).toFixed(2)">
                    与上年决算相同；
                </span>
                <span v-else>
                    比上年决算{{growthValueText(T9.items.运行费,T9.items_last.运行费)}}万元，
                    主要原因为<reason type="textarea" classname="qksm widest semicolon" name="运行费决算原因" v-model:value="qksm['运行费决算原因']"></reason>
                </span>
                <span v-if="num(T9.items.运行费)!=num(qksm['运行费年初'])">
                    决算数{{num(T9.items.运行费)>num(qksm['运行费年初']) ? "大于" : "小于"}}预算数的主要原因
                    <reason type="textarea" classname="qksm widest" name="运行费预算原因" v-model:value="qksm['运行费预算原因']"></reason>
                </span>
                <span v-else>
                    决算数等于预算数。
                </span>
                <template v-if="num(T9.items.运行费)!=0">
                    公务用车运行维护费主要用于
                    <reason type="textarea" classname="qksm widest" name="公务用车运行用于" v-model:value="qksm['公务用车运行用于']"></reason>
                </template>
                2020年使用一般公共预算拨款开支运行维护费的公务用车保有量{{T9.统计数[1].f}}辆。
            </p>
            <p>
                3．公务接待费{{isMoney(T9.items.公务接待)}}万元
                <span class="hide_pdf">
                    （预算数<reason type="money" classname="qksm money" name="公务接待年初" v-model:value="qksm['公务接待年初']"></reason>万元，
                    去年决算数<reason type="money" classname="qksm money nullable" name="公务接待去年" v-model:value="T9.items_last.公务接待"></reason>万元）
                </span>
                <span v-if="num(qksm['公务接待年初'])==0">
                    {{$store.state.divData.zone=='xuzhou' ? "，年初无预算，" : "（预算数为0万元，无法计算完成比例），"}}
                </span>
                <span v-else>
                    ， 完成预算的{{calcRatio(T9.items.公务接待,qksm['公务接待年初'])}}，
                </span>
                <span v-if="num(T9.items.公务接待).toFixed(2)==num(T9.items_last.公务接待).toFixed(2)">
                    与上年决算相同；
                </span>
                <span v-else>
                    比上年决算{{growthValueText(T9.items.公务接待,T9.items_last.公务接待)}}万元，
                    主要原因为<reason type="textarea" classname="qksm widest semicolon" name="公务接待决算原因" v-model:value="qksm['公务接待决算原因']"></reason>
                </span>
                <span v-if="num(T9.items.公务接待)!=num(qksm['公务接待年初'])">
                    决算数{{num(T9.items.公务接待)>num(qksm['公务接待年初']) ? "大于" : "小于"}}预算数的主要原因
                    <reason type="textarea" classname="qksm widest" name="公务接待预算原因" v-model:value="qksm['公务接待预算原因']"></reason>
                </span>
                <span v-else>
                    决算数等于预算数。
                </span>
                其中：国内公务接待支出
                <template v-if="num(T9.items.公务接待)==0 || (T9.统计数[2].c==0 && T9.统计数[2].f==0)">
                    0
                </template>
                <reason v-else type="money" classname="qksm money" name="国内接待费" v-model:value="qksm['国内接待费']"></reason>
                万元，
                接待{{T9.统计数[2].c}}批次，{{T9.统计数[2].f}}人次
                <template v-if="num(qksm['国内接待费'])!=0">
                    ，主要为接待
                    <reason type="textarea" classname="qksm widest semicolon" name="国内接待为" v-model:value="qksm['国内接待为']"></reason>
                </template>
                <template v-else>
                    ；
                </template>
                国（境）外公务接待支出
                <template v-if="num(T9.items.公务接待)==0 || (T9.统计数[3].c==0 && T9.统计数[3].f==0)">
                    0
                </template>
                <reason v-else type="money" classname="qksm money" name="国外接待费" v-model:value="qksm['国外接待费']"></reason>
                万元，
                接待{{T9.统计数[3].c}}批次，{{T9.统计数[3].f}}人次
                <template v-if="num(qksm['国外接待费'])!=0">
                    ，主要为接待
                    <reason type="textarea" classname="qksm widest" name="国外接待为" v-model:value="qksm['国外接待为']"></reason>
                </template>
                <template v-else>
                    。
                </template>


            </p>
            <p>
                {{$store.state.divData.divname}}2020年度一般公共预算拨款安排的会议费决算支出{{isMoney(T9.items.会议费)}}万元
                <span class="hide_pdf">
                    （预算数<reason type="money" classname="qksm money" name="会议费年初" v-model:value="qksm['会议费年初']"></reason>万元，
                    去年决算数<reason type="money" classname="qksm money nullable" name="会议费去年" v-model:value="T9.items_last.会议费"></reason>万元）
                </span>
                <span v-if="num(qksm['会议费年初'])==0">
                    {{$store.state.divData.zone=='xuzhou' ? "，年初无预算，" : "（预算数为0万元，无法计算完成比例），"}}
                </span>
                <span v-else>
                    ，完成预算的{{calcRatio(T9.items.会议费,qksm['会议费年初'])}}，
                </span>
                <span v-if="num(T9.items.会议费).toFixed(2)==num(T9.items_last.会议费).toFixed(2)">
                    与上年决算相同；
                </span>
                <span v-else>
                    比上年决算{{growthValueText(T9.items.会议费,T9.items_last.会议费)}}万元，
                    主要原因为<reason type="textarea" classname="qksm widest semicolon" name="会议费决算原因" v-model:value="qksm['会议费决算原因']"></reason>
                </span>
                <span v-if="num(T9.items.会议费)!=num(qksm['会议费年初'])">
                    决算数{{num(T9.items.会议费)>num(qksm['会议费年初']) ? "大于" : "小于"}}预算数的主要原因
                    <reason type="textarea" classname="qksm widest" name="会议费预算原因" v-model:value="qksm['会议费预算原因']"></reason>
                </span>
                <span v-else>
                    决算数等于预算数。
                </span>
                2020年度全年召开会议{{T9.统计数[4].c}}个，参加会议{{T9.统计数[4].f}}人次。
                <template v-if="num(T9.items.会议费)!=0">
                    主要为召开
                    <reason type="textarea" classname="qksm widest" name="会议费主要为" v-model:value="qksm['会议费主要为']"></reason>
                </template>
            </p>
            <p>
                {{$store.state.divData.divname}}2020年度一般公共预算拨款安排的培训费决算支出{{isMoney(T9.items.培训费)}}万元
                <span class="hide_pdf">
                    （预算数<reason type="money" classname="qksm money" name="培训费年初" v-model:value="qksm['培训费年初']"></reason>万元，
                    去年决算数<reason type="money" classname="qksm money nullable" name="培训费去年" v-model:value="T9.items_last.培训费"></reason>万元）
                </span>
                <span v-if="num(qksm['培训费年初'])==0">
                    {{$store.state.divData.zone=='xuzhou' ? "，年初无预算，" : "（预算数为0万元，无法计算完成比例），"}}
                </span>
                <span v-else>
                    ，完成预算的{{calcRatio(T9.items.培训费,qksm['培训费年初'])}}，
                </span>
                <span v-if="num(T9.items.培训费).toFixed(2)==num(T9.items_last.培训费).toFixed(2)">
                    与上年决算相同；
                </span>
                <span v-else>
                    比上年决算{{growthValueText(T9.items.培训费,T9.items_last.培训费)}}万元，
                    主要原因为<reason type="textarea" classname="qksm widest semicolon" name="培训费决算原因" v-model:value="qksm['培训费决算原因']"></reason>
                </span>
                <span v-if="num(T9.items.培训费)!=num(qksm['培训费年初'])">
                    决算数{{num(T9.items.培训费)>num(qksm['培训费年初']) ? "大于" : "小于"}}预算数的主要原因
                    <reason type="textarea" classname="qksm widest" name="培训费预算原因" v-model:value="qksm['培训费预算原因']"></reason>
                </span>
                <span v-else>
                    决算数等于预算数。
                </span>
                2020年度全年组织培训{{T9.统计数[5].c}}个，组织培训{{T9.统计数[5].f}}人次。
                <template v-if="num(T9.items.培训费)!=0">
                    主要为培训
                    <reason type="textarea" classname="qksm widest" name="培训费主要为" v-model:value="qksm['培训费主要为']"></reason>
                </template>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm9",
        data() {
            var qksm = this.$store.state.divData.qksm;
            for (var i = 0; i < this.T9.统计数.length; i++) {
                if (qksm[i + 'c三公'])
                    this.T9.统计数[i].c = qksm[i + 'c三公'];
                if (qksm[i + 'f三公'])
                    this.T9.统计数[i].f = qksm[i + 'f三公'];
            }
            for (var prop in this.T9.items_last) {
                let v = qksm[prop + '去年'];
                if (v)
                    this.T9.items_last[prop] = v;
            }
            if (this.T9.items_ys) {
                for (var prop in this.T9.items_ys) {
                    let v = this.T9.items_ys[prop];
                    qksm[prop + '年初'] = this.pickOneOf(qksm[prop + '年初'], this.num(v))
                }
            }
            if (this.num(this.T9.items.公务接待) == 0) {
                qksm['国内接待费'] = 0
                qksm['国外接待费']=0
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm
            }
        },
        props: {
            T9: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        watch: {
            'qksm.国内接待费'() {
                this.inspect()
            },
            'qksm.国外接待费'() {
                this.inspect()
            }
        },
        created() {
            this.inspect()
        },
        methods: {
            inspect() {
                if (this.num(this.T9.items.公务接待).toFixed(2) != this.num(this.num(this.qksm['国内接待费']) + this.num(this.qksm['国外接待费'])).toFixed(2)) {
                    this.addOrSet("qksm9", "请检查本页《九、一般公共预算财政拨款“三公”经费、会议费、培训费支出情况说明》，国内公务接待与国（境）外公务接待之和与公务接待费不相等。");
                } else {
                    this.remove("qksm9")
                }
            }
        }
    };
</script>